<template>
	<div class="previous-request">
		<div>
			<div class="dot" :class="{unread: !request.is_readed}"></div>

			<p class="title">{{ $t('Výsledok k žiadanke č.') }} <b>{{ request.request_id }}</b></p>
		</div>

		<div>
			<p v-if="request?.creation_date" class="date">{{ formatDate(request.creation_date) }}</p>
			<p class="open" @click="$emit('open-request', request)">{{ $t('Zobraziť') }}</p>
		</div>
	</div>
</template>

<script>
import { formatDate } from '@/plugins/app/utils/date.utils'

export default {
	emits: ['open-request'],

	data() {
		return {
			formatDate
		}
	},

	props: {
		request: {
			type: [Object, null],
			default: () => null,
		}
	}
}
</script>

<style scoped lang="sass">
@import '@/plugins/app/theme/_mixins/responsive.mixin'

.previous-request
	@apply flex justify-between items-center

	div
		@apply flex justify-between items-center

	.title
		@apply text-[16px]
		line-height: 24px

	.date
		@apply text-[--ion-color-medium]

	.open
		@apply text-[--ion-color-primary] cursor-pointer px-[10px] py-[2px] ml-[20px]

		&:hover
			@apply text-[--ion-color-primary-shade]

	.dot
		@apply bg-[--ion-color-medium] h-[10px] w-[10px] rounded-full mr-[10px] mt-[-2px] opacity-50

		&.unread
			@apply bg-[--ion-color-primary] opacity-100
</style>
